import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { ImportRow } from "@/mocks/import-work-orders";

function ValidityChip({ row }: { row: ImportRow }) {
  if (row.isValid) {
    return (
      <span className="inline-flex items-center rounded-full bg-[var(--success-bg)] px-2.5 py-0.5 text-xs font-semibold text-[var(--success)]">
        Valid
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center rounded-full bg-[var(--danger-bg)] px-2.5 py-0.5 text-xs font-semibold text-[var(--danger)]"
      title={row.errors.join("; ")}
    >
      Invalid
    </span>
  );
}

interface ImportRowsTableProps {
  rows: ImportRow[];
}

export function ImportRowsTable({ rows }: ImportRowsTableProps) {
  return (
    <Card>
      <CardContent>
        <div className="max-h-96 overflow-auto rounded-lg border">
          <table className="w-full border-collapse text-sm">
            <thead className="sticky top-0 bg-muted text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="px-3 py-2 text-left">Row</th>
                <th className="px-3 py-2 text-left">Item</th>
                <th className="px-3 py-2 text-right">Qty</th>
                <th className="px-3 py-2 text-left">Location</th>
                <th className="px-3 py-2 text-left">Start date</th>
                <th className="px-3 py-2 text-left">End date</th>
                <th className="px-3 py-2 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr
                  key={row.id}
                  className={cn("border-t", !row.isValid && "bg-[var(--danger-bg)]/40")}
                >
                  <td className="px-3 py-2 whitespace-nowrap">{row.rowNumber}</td>
                  <td
                    className={cn(
                      "px-3 py-2 whitespace-nowrap",
                      !row.isValid && "text-[var(--danger)]",
                    )}
                  >
                    {row.item || "—"}
                  </td>
                  <td
                    className={cn(
                      "px-3 py-2 text-right whitespace-nowrap",
                      !row.isValid && "text-[var(--danger)]",
                    )}
                  >
                    {row.quantity || "—"}
                  </td>
                  <td
                    className={cn(
                      "px-3 py-2 whitespace-nowrap",
                      !row.isValid && "text-[var(--danger)]",
                    )}
                  >
                    {row.location || "—"}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap">{row.startDate || "—"}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{row.endDate || "—"}</td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    <ValidityChip row={row} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
